import { Component, OnInit, Optional, Self, ChangeDetectionStrategy } from '@angular/core';
import { BaseInputComponent } from '../base-input';
import { NgControl, FormControl, NG_VALIDATORS, Validators } from '@angular/forms';
import { FieldConventionService, ValidationMessageService } from 'src/app/stp/stp-app/forms';

export const validateEmailFactory = () => {
  return (control: FormControl) => {
      if (!control.value) {
        return null;
      }

      return Validators.email(control);
    };
  };

@Component({
  selector: 'stp-input-email',
  templateUrl: './input-email.component.html',
  providers: [
    {
      provide: NG_VALIDATORS,
      useFactory: validateEmailFactory,
      multi: true
    }
  ]
})
export class InputEmailComponent extends BaseInputComponent implements OnInit {

  constructor(@Optional() @Self() ngControl: NgControl,
    fieldConventionService: FieldConventionService,
    validationMessageService: ValidationMessageService) {
    super(ngControl, fieldConventionService, validationMessageService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
